import axios from 'axios';
import { BASE_URL } from './config';

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// ✅ Request interceptor: tự động thêm token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ✅ Response interceptor: xử lý lỗi 401, 403
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            // Xoá token & redirect nếu cần
            localStorage.removeItem('accessToken');
            window.location.href = '/login'; // hoặc dùng navigate từ react-router
        }
        return Promise.reject(error);
    }
);

export default api;
